import { ListColumn, ListDataColumn } from "../ListColumn";
import { MeddraListView } from "./MeddraListView";

export class PTListView extends MeddraListView {

    constructor(items: any) {
        let itemsWithChecked = items;
        if (itemsWithChecked && itemsWithChecked.length>0) {
            itemsWithChecked = items.map((info: any) => ({checked: false, ...info}));
        }

        const itemFinderArrayColumns: ListColumn[] = [
            new ListColumn("Num", ListDataColumn.TEXT, "num"),
            new ListColumn("PT Name", ListDataColumn.TEXT, "name"),
            new ListColumn("PT Code", ListDataColumn.TEXT, "code")
        ];
        const itemFinderTreeColumns: ListColumn[] = [
            new ListColumn("PT Name", ListDataColumn.TEXT, "name"),
            new ListColumn("PT Code", ListDataColumn.TEXT, "code")
        ];

        super(itemsWithChecked,  itemFinderArrayColumns, itemFinderTreeColumns);   
    }

}